import React from "react";
import discover1 from "../images/ifsr9.svg";
import discover2 from "../images/basel34.png";
import discover3 from "../images/business-performance.png";
import discover4 from "../images/esg_reporting.svg";
import Arrow_up_small from "../../Arrow_up_small.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HomeDiscoverPart = () => {
  const navigate = useNavigate();

  const discoverArray = [
    {
      title: "IFRS9",
      subText:
        "IFRS9 reporting made easy: Preconfigured reports, automated report refresh, variance analysis & drill-down for fast insights.",
      image: discover1,
      navigate: "/bug-bounty",
      section: "Ifrs9",
    },
    {
      title: "BASEL III/IV",
      subText:
        "Streamlined BASEL III/IV: Ready-made reports, drill-down analysis, future-proof for ICAAP & IRB.",
      image: discover2,
      navigate: "/auditing",
      section: "Basel3",
    },
    {
      title: "Business Performance",
      subText:
        "Automated business performance reporting empowers banks to gain a clearer picture of their financial health, identify opportunities for growth, and make data-driven decisions for a more competitive advantage.",
      image: discover3,
      navigate: "/penetration",
      section: "BusinessPerformance",
    },
    {
      title: "ESG",
      subText:
        "Automated ESG reporting helps banks become more transparent and accountable to environmentally and socially conscious investors and customers.",
      image: discover4,
      navigate: "/contact-us",
      section: "Esg",
    },
  ];

  return (
    <div className="container mx-auto px-2 pb-0 sm:pb-10 xl:max-w-[1000px] 3xl:max-w-[1200px]">
      <div className="text-[#141619]  text-[22px] sm:text-[32px] md:text-[35px] 3xl:text-[54px] font-[700] flex flex-col justify-center items-center">
        <span className="sora md:leading-[63px]">Reporting</span>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-7 pt-10 sm:pt-16">
        {/* {
                    discoverArray.map((discoverArray[0], i) => {
                        return ( */}
        <div
          id={discoverArray[0].section}
          className="bg-[#F5F5F5] rounded-[20px] p-3 sm:p-7 relative min-h-[410px] sm:min-h-[auto] sm:h-[460px] lg:h-[500px]"
        >
          <div className="flex flex-col justify-between items-stretch sm:min-h-[270px] md:min-h-[222px]">
            <div>
              <h1 className="sora capitalize text-[16px] leadeing-[28px]  sm:leading-[42px] sm:text-[19px] 3xl:text-[28px] font-[700]  text-[#000]">
                {discoverArray[0].title}
              </h1>
              <span className="NunitoSans text-[#141619] text-[14px] 3xl:text-[18px] font-[400]">
                {discoverArray[0].subText}
              </span>
            </div>
            <div className="pt-8">
              <div
                className="getStartedBtnOuter relative z-[2]"
                onClick={() => navigate("/contact-us")}
              >
                <Button className="NunitoSans getStartedBtn">
                  Learn More
                  <img
                    draggable="false"
                    src={Arrow_up_small}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
            </div>
          </div>
          {discoverArray[0]?.image ? (
            <img
              draggable="false"
              src={discoverArray[0].image}
              className={`absolute bottom-0 right-0 z-[1] min-w-[200px] sm:min-w-[auto] sm: max-w-[280px] md:max-w-[250px] lg:max-w-[300px] 2xl:max-w-[350px] left-[50%] translate-x-[-50%] md:left-[unset] md:translate-x-[0%]`}
              alt="discover_images"
            />
          ) : null}
        </div>
        <div
          id={discoverArray[1].section}
          className="bg-[#F5F5F5] rounded-[20px] p-3 sm:p-7 relative min-h-[410px] sm:min-h-[auto] sm:h-[460px] lg:h-[500px]"
        >
          <div className="flex flex-col justify-between items-stretch sm:min-h-[270px] md:min-h-[222px]">
            <div>
              <h1 className="sora capitalize text-[16px] leadeing-[28px]  sm:leading-[42px] sm:text-[19px] 3xl:text-[28px] font-[700]  text-[#000]">
                {discoverArray[1].title}
              </h1>
              <span className="NunitoSans text-[#141619] text-[14px] 3xl:text-[18px] font-[400]">
                {discoverArray[3].subText}
              </span>
            </div>
            <div className="pt-8">
              <div
                className="getStartedBtnOuter relative z-[2]"
                onClick={() => navigate(discoverArray[3].navigate)}
              >
                <Button className="NunitoSans getStartedBtn">
                  Learn More
                  <img
                    draggable="false"
                    src={Arrow_up_small}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
            </div>
          </div>
          {discoverArray[1]?.image ? (
            <img
              draggable="false"
              src={discoverArray[1].image}
              className={`absolute bottom-0 right-0 z-[1] max-w-[280px] md:max-w-[250px] lg:max-w-[300px] 2xl:max-w-[350px] left-[50%] translate-x-[-50%] md:left-[unset] md:translate-x-[0%]`}
              alt="discover_images"
            />
          ) : null}
        </div>
        <div
          id={discoverArray[2].section}
          className="bg-[#F5F5F5] rounded-[20px] p-3 sm:p-7 relative min-h-[410px] sm:min-h-[auto] sm:h-[460px] lg:h-[500px]"
        >
          <div className="flex flex-col justify-between items-stretch sm:min-h-[270px] md:min-h-[222px]">
            <div>
              <h1 className="sora capitalize text-[16px] leadeing-[28px]  sm:leading-[42px] sm:text-[19px] 3xl:text-[28px] font-[700]  text-[#000]">
                {discoverArray[2].title}
              </h1>
              <span className="NunitoSans text-[#141619] text-[14px] 3xl:text-[18px] font-[400]">
                {discoverArray[3].subText}
              </span>
            </div>
            <div className="pt-8">
              <div
                className="getStartedBtnOuter relative z-[2]"
                onClick={() => navigate(discoverArray[3].navigate)}
              >
                <Button className="NunitoSans getStartedBtn">
                  Learn More
                  <img
                    draggable="false"
                    src={Arrow_up_small}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
            </div>
          </div>
          {discoverArray[2]?.image ? (
            <img
              draggable="false"
              src={discoverArray[2].image}
              className={`absolute bottom-0 right-0 z-[1] max-w-[200px] md:max-w-[220px] lg:max-w-[300px] 2xl:max-w-[350px] left-[50%] translate-x-[-50%] md:left-[unset] md:translate-x-[0%]`}
              alt="discover_images"
            />
          ) : null}
        </div>
        <div
          id={discoverArray[3].section}
          className="bg-[#F5F5F5] rounded-[20px] p-3 sm:p-7 relative min-h-[410px] sm:min-h-[auto] sm:h-[460px] lg:h-[500px]"
        >
          <div className="flex flex-col justify-between items-stretch sm:min-h-[270px] md:min-h-[222px]">
            <div>
              <h1 className="sora capitalize text-[16px] leadeing-[28px]  sm:leading-[42px] sm:text-[19px] 3xl:text-[28px] font-[700]  text-[#000]">
                {discoverArray[3].title}
              </h1>
              <span className="NunitoSans text-[#141619] text-[14px] 3xl:text-[18px] font-[400]">
                {discoverArray[3].subText}
              </span>
            </div>
            <div className="pt-8">
              <div
                className="getStartedBtnOuter relative z-[2]"
                onClick={() => navigate(discoverArray[3].navigate)}
              >
                <Button className="NunitoSans getStartedBtn">
                  Learn More
                  <img
                    draggable="false"
                    src={Arrow_up_small}
                    className="w-[9px] sm:w-[12px] ml-[4px]"
                    alt="Arrow_up_small"
                  />
                </Button>
              </div>
            </div>
          </div>
          {discoverArray[3]?.image ? (
            <img
              draggable="false"
              src={discoverArray[3].image}
              className={`absolute translate-y-[20px] lg:translate-y-[40px] bottom-0 right-0 z-[1] min-w-[220px] sm:min-w-[auto]  max-w-[280px] md:max-w-[250px] lg:max-w-[300px] 2xl:max-w-[350px] left-[50%] translate-x-[-50%] lg:translate-x-5 md:left-[unset] md:translate-x-[0%]`}
              alt="discover_images"
            />
          ) : null}
        </div>
        {/* )
                    })
                } */}
      </div>
    </div>
  );
};

export default HomeDiscoverPart;
